import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
  Router,
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication';
import { catchError, map, mapTo, of, tap } from 'rxjs';

export const resetPasswordGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const redirectToForgotPassword = () =>
    router.createUrlTree(['login', 'forgot-password'], {
      queryParams: { invalidResetToken: true },
    });

  const token = route.paramMap.get('token');
  const user = route.paramMap.get('user');

  if (!token || !user) {
    return redirectToForgotPassword();
  }

  return authService.validateResetPassword(token, user).pipe(
    catchError(error => {
      redirectToForgotPassword();
      return of(false);
    }),
    map(() => true)
  );
};
